import {gql} from '@apollo/client';

export const GET_CATALOGS = gql`
  query Catalogs($type: CatalogType!, $country: String!) {
    catalogs(type: $type, country: $country) {
      name
      id
      description
      children {
        name
        id
        description
      }
    }
  }
`;

export const GET_INABILITY_CONFIGURATIONS = gql`
  query getInabilityConfigurations($country: String!) {
    getInabilityConfigurations(country: $country) {
      data {
        country
        createdAt
        days
        id
        status
        updatedAt
        inabilityType {
          id
          description
          name
          type
        }
      }
    }
  }
`;

export const GET_MONETIZATION_CONFIGURATIONS = gql`
  query GetMonetizationConfigurations(
    $country: String!
    $status: String
    $leaveTypeName: String
  ) {
    getMonetizationConfigurations(
      country: $country
      status: $status
      leaveTypeName: $leaveTypeName
    ) {
      data {
        id
        country
        leaveType {
          id
          name
          description
        }
        days
        status
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_CATALOGS_BY_TYPE = gql`
  query CatalogsByType($type: CatalogType!) {
    catalogsByType(type: $type) {
      id
      name
      children {
        id
        name
        description
      }
      description
      type
    }
  }
`;

export const GET_PUBLIC_HOLIDAYS = gql`
  query PublicHolidays($countryCode: String!, $year: Float) {
    publicHolidays(countryCode: $countryCode, year: $year) {
      name
      date
    }
  }
`;

export const GET_LEAVE_HISTORY = gql`
  query LeaveHistory(
    $userId: String!
    $sort: SortInput
    $pageParams: PageInput
  ) {
    leaveHistory(userId: $userId, sort: $sort, pageParams: $pageParams) {
      currentPage
      hasNextPage
      pageSize
      rows {
        id
        createdAt
        daysOff
        endDate
        startDate
        typeOfLeave {
          name
          description
        }
        status
      }
      total
    }
  }
`;

// Deprecated: use GET_LEAVE_REQUEST_BY_APPROVAL instead
export const GET_LEAVE_PENDING_APPROVALS = gql`
  query PendingApprovals($approvalId: String!, $pageParams: PageInput) {
    pendingApprovals(approvalId: $approvalId, pageParams: $pageParams) {
      total
      pageSize
      hasNextPage
      currentPage
      rows {
        id
        userName
        startDate
        endDate
        typeOfLeave {
          description
        }
      }
    }
  }
`;

export const GET_LEAVE_DETAILS = gql`
  query LeaveRequestDetails($leaveRequestId: String!) {
    leaveRequestDetails(leaveRequestId: $leaveRequestId) {
      id
      createdAt
      daysOff
      userId
      userName
      typeOfLeave {
        id
        description
        name
        type
      }
      status
      endDate
      startDate
      scheduleOptions
      evidences {
        evidenceType
        url
      }
      approvals {
        approvalRole
        approvalStatus
        order
        comment
        approvalId
        date
        name
        email
      }
      comments
      modificationData {
        reasonId
        reasonName
        userId
      }
    }
  }
`;

export const GET_NEXT_LEAVE = gql`
  query NextLeave($userId: String!, $fromDate: String!) {
    nextLeave(userId: $userId, fromDate: $fromDate) {
      daysOff
      startDate
      endDate
      status
      id
    }
  }
`;

export const GET_USERS_ON_LEAVE = gql`
  query UsersOnLeave($sort: SortInput, $pageParams: PageInput) {
    usersOnLeave(sort: $sort, pageParams: $pageParams) {
      total
      pageSize
      hasNextPage
      currentPage
      rows {
        name
        startDate
        endDate
        daysOff
        assignationType
      }
    }
  }
`;

export const GET_USER_BY_EMAIL = gql`
  query User($email: String!) {
    user(email: $email) {
      assignationType
      country
      email
      firstName
      hiringDate
      id
      lastName
      isSupervisor
      role
      leaveBalance {
        userId
        availableDays
        vacationDays
        additionalLeaveDays
        totalAdditionalLeaveDays
        usedAdditionalLeaves
        accumulatedDays
        daysToExpire {
          type
          days
          date
        }
        usedDays
      }
    }
  }
`;

export const GET_EVIDENCE_URL = gql`
  query UrlSignedEvidence($filename: String!) {
    urlSignedEvidence(filename: $filename)
  }
`;

export const GET_ADDITIONAL_LEAVES = gql`
  query Query($sort: SortInput, $pageParams: PageInput, $username: String) {
    additionalLeaves(
      sort: $sort
      pageParams: $pageParams
      username: $username
    ) {
      currentPage
      hasNextPage
      pageSize
      rows {
        id
        name
        expirationDate
        days
        activationDate
        userId
        type
        description
      }
      total
    }
  }
`;

export const GET_LEAVE_REQUEST_BY_APPROVAL = gql`
  query Query(
    $approvalId: String!
    $statusLeave: [LeaveStatus]
    $statusApproval: [ApprovalStatus]
    $onlyInOrder: Boolean!
    $sort: SortInput
    $pageParams: PageInput
    $isAdmin: Boolean!
    $filter: LeaveRequestFilter
  ) {
    leaveRequestsByApproval(
      approvalId: $approvalId
      statusLeave: $statusLeave
      statusApproval: $statusApproval
      onlyInOrder: $onlyInOrder
      sort: $sort
      pageParams: $pageParams
      isAdmin: $isAdmin
      filter: $filter
    ) {
      currentPage
      hasNextPage
      pageSize
      rows {
        id
        userName
        startDate
        endDate
        createdAt
        countryCode
        typeOfLeave {
          id
          name
          description
        }
        daysOff
        status
        assignationType
      }
      total
    }
  }
`;

export const GET_DAYS_TO_EXPIRE = gql`
  query UserDaysToExpire($sort: SortInput, $pageParams: PageInput) {
    daysToExpireList(sort: $sort, pageParams: $pageParams) {
      currentPage
      hasNextPage
      pageSize
      rows {
        date
        firstName
        daysToExpire
        lastName
        userId
      }
      total
    }
  }
`;

export const GET_VACATION_RULES_BY_SENIORITY = gql`
  query VacationRulesBySeniority($country: String) {
    vacationRulesBySeniority(country: $country) {
      status
      country {
        code
        name
      }
      rules {
        fromYear
        toYear
        vacationDays
        label
      }
      timestamp
    }
  }
`;

export const GET_STATE_REPORT = gql`
  query GetStateReport($filter: FilterReport!) {
    currentStateReport(filter: $filter)
  }
`;

export const GET_ABSENCE_SUMMARY_REPORT = gql`
  query Query($filter: FilterReport) {
    absenceSummaryReport(filter: $filter)
  }
`;

export const GET_CONFIGURATIONS = gql`
  query GetConfigurations {
    getConfigurations {
      holidays {
        year
        holidays {
          date
          name
        }
      }
      inabilities {
        numberOfDays
        type {
          id
          name
          type
          description
        }
      }
      id
      country
      vacations {
        timeInService
        vacationDays
      }
      monetizationRules {
        allowsAccumulation
        maxAccumulationMonths
        maxDaysToMonetize
      }
    }
  }
`;

export const GET_CONFIGURED_COUNTRIES = gql`
  query GetConfiguredCountries {
    getConfigurations(includeInactive: false) {
      id
      country
    }
  }
`;

/**
 * Retrieves management configuration data including full vacation regulation history.
 * Accepts an optional flag to include inactive country configurations.
 */
export const GET_MANAGEMENT_CONFIGURATIONS = gql`
  query GetManagementConfigurations($includeInactive: Boolean) {
    getConfigurations(includeInactive: $includeInactive) {
      holidays {
        year
        holidays {
          date
          name
        }
      }
      inabilities {
        numberOfDays
        type {
          id
          name
          type
          description
        }
      }
      id
      country
      status
      isActive
      disabledAt
      disabledReason
      disabledBy
      vacations {
        timeInService
        vacationDays
      }
      vacationRegulations {
        id
        country
        effectiveFrom
        effectiveTo
        isCurrent
        isEditable
        vacationRanges {
          fromYear
          toYear
          vacationDays
        }
      }
      monetizationRules {
        allowsAccumulation
        maxAccumulationMonths
        maxDaysToMonetize
      }
    }
  }
`;

export const GET_ABSENCE_SUMMARY = gql`
  query GetAbsenceSummary($filter: FilterReport, $page: Float, $size: Float) {
    getAbsenceSummary(filter: $filter, page: $page, size: $size) {
      total
      pageSize
      hasNextPage
      currentPage
      rows {
        country
        name
        lastname
        rol
        bussinessUnit
        supervisor
        client
        balance {
          vacationDays
          additionalLeaveDays
          nextVacationsToExpire
          nextAdditionalLeaveToExpire
          vacationDaysExpired
          additionalLeaveDaysExpired
          timeSinceLastVacation
          vacationDaysTaken
        }
      }
    }
  }
`;

export const FILTER_USERS = gql`
  query FilterUsers($keyword: String, $countries: [String!]) {
    filterUsers(keyword: $keyword, countries: $countries) {
      id
      email
      firstName
      lastName
      country
    }
  }
`;

export const GET_MONETIZATION_BALANCE = gql`
  query GetMonetizationBalance($userId: String!, $country: String!) {
    getMonetizationBalance(userId: $userId, country: $country) {
      availableDays
      usedDays
      expirationDate
    }
  }
`;

export const GET_REASSIGNMENT_PROPOSALS = gql`
  query GetReassignmentProposals($countryCode: String!) {
    getReassignmentProposals(countryCode: $countryCode) {
      totalAffected
      proposals {
        userId
        userEmail
        userName
        currentCountry
        suggestedCountries {
          countryCode
          priority
          reason
        }
      }
    }
  }
`;
